export default "__VITE_ASSET__DTOSfD7O__"